(function () {
  'use strict';

  angular
    .module('settings.stacking.plan')
    .factory('SettingsStackingPlan', SettingsStackingPlan);

  SettingsStackingPlan.$inject = ['$resource'];

  function SettingsStackingPlan($resource) {
    return $resource(
      '/api/',
      {},
      {
        getUnitFeatureList: {
          method: 'GET',
          url: 'api/customization/label/all',
          isArray: true,
        },
        create: {
          method: 'POST',
          url: 'api/customization/create/:custom_type',
        },
        update: {
          method: 'POST',
          url: 'api/customization/update/:custom_type/:id',
        },
        delete: {
          method: 'POST',
          url: 'api/customization/delete/:custom_type/:id',
        },
      },
    );
  }
})();
